import React from 'react'
import {DealActivityItemBase, Hub} from 'yougile-model'
import {IconButton} from '@components/common/base/buttons/icon-button/icon-button'
import {showDeleteConfirm} from '@components/common/base/notifications/show-confirm'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {deleteDealActivityItem} from './delete-deal-activity-item'

interface DealActivityDeleteButtonProps {
  deal: Hub
  activity: DealActivityItemBase
  tooltip: string
  confirmationTitle: string
  confirmationDescription: string
}

export const DealActivityDeleteButton = ({
  deal,
  activity,
  tooltip,
  confirmationTitle,
  confirmationDescription
}: DealActivityDeleteButtonProps) => {
  return (
    <Tooltip content={tooltip}>
      <IconButton
        icon="IconTrash"
        onClick={async () => {
          const msg = {
            title: confirmationTitle,
            subtitle: confirmationDescription
          }

          if (await showDeleteConfirm(msg)) {
            deleteDealActivityItem(deal, activity)
          }
        }}
        className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        size="small"
        color="secondary"
      />
    </Tooltip>
  )
}
